<template >
  <div>
    <div>
      <div class="formPosition">
        <v-card style="margin:auto;" width="1240">
          <v-card-title style="background-color:#006699;color:white;">Relatórios de entrada</v-card-title>
          <v-progress-linear style="margin : 0 auto ; height:10px" :indeterminate="isLoading" v-show="isLoading"></v-progress-linear>
          <v-tabs v-model="tab">
            <v-tabs-slider></v-tabs-slider>
            <!-- <v-tab href="#tab-1"> Entrada Geral </v-tab> -->
            <v-tab href="#tab-2" v-if=" funcaoPorROle.verificarFuncao(25)"> Entrada detalhado </v-tab>
            <v-tab href="#tab-4" v-if=" funcaoPorROle.verificarFuncao(26)"> Bancos detalhado </v-tab>
            <v-tab href="#tab-5" v-if=" funcaoPorROle.verificarFuncao(27)"> Bancos Geral </v-tab>
            <v-tab href="#tab-3" v-if=" funcaoPorROle.verificarFuncao(28)"> Emolumentos Geral</v-tab>
            <!-- <v-tab href="#tab-6" v-if=" funcaoPorROle.verificarFuncao(29)"> Emolumentos Por Classe</v-tab> -->
            <v-tab href="#tab-7" v-if=" funcaoPorROle.verificarFuncao(30)"> Emolumentos Por Turma</v-tab>
          </v-tabs>

          <v-tabs-items v-model="tab">
            <!-- <v-tab-item :value="'tab-1'"> <entrada-geral></entrada-geral> </v-tab-item> -->
            <v-tab-item :value="'tab-2'"> <entrada-detalhes></entrada-detalhes> </v-tab-item>
            <v-tab-item :value="'tab-3'"> <emolumento></emolumento> </v-tab-item>
            <v-tab-item :value="'tab-4'"> <bancoDetalhes></bancoDetalhes> </v-tab-item>
            <v-tab-item :value="'tab-5'"> <bancoGeral></bancoGeral> </v-tab-item>
            <v-tab-item :value="'tab-6'"> <emolumento-classe></emolumento-classe> </v-tab-item>
            <v-tab-item :value="'tab-7'"> <emolumento-turma></emolumento-turma> </v-tab-item>
          </v-tabs-items>
        </v-card>
      </div>
    </div>
  </div>
</template>
<script>
import axios from '../../plugins/axios'
import utilitarios from '../../plugins/utilitarios'
import funcaoPorROle from '../../utilitarios/funcao.untilitario'
import entradaGeral from './relatorioComponentes/entradaGeral.vue'
import entradaDetalhes from './relatorioComponentes/entradaDetalhes.vue'
import emolumento from './relatorioComponentes/emolumento.vue'
import emolumentoClasse from './relatorioComponentes/emolumentoClasse.vue'
import emolumentoTurma from './relatorioComponentes/emolumentoTurma.vue'
import bancoDetalhes from './relatorioComponentes/bancoDetalhes.vue'
import bancoGeral from './relatorioComponentes/bancoGeral.vue'
const ls = require('local-storage')
export default {
  components: {
    entradaGeral,
    entradaDetalhes,
    emolumento,
    emolumentoClasse,
    emolumentoTurma,
    bancoDetalhes,
    bancoGeral
  },
  data: () => ({
    funcaoPorROle: funcaoPorROle,
    valid: true,
    isLoading: false,
    tab: 1,
    headers: [
      {
        text: 'Descrição',
        align: 'left',
        sortable: false,
        value: 'descricao'
      },
      { text: 'Nível', value: 'nivel' },
      { text: 'Data criação', value: 'data_' },
      { text: 'Autor', value: 'autor' }
    ],
    turmas: [],
    classes: [],
    classesFiltered: [],
    searchInDb: '',
    cursos: [],
    periodos: [
      { id: "M", descricao: 'Manhã' },
      { id: 'T', descricao: 'Tarde' },
      { id: 'N', descricao: 'Noite' }
    ],
    dialog: false,
    overlay: false,
    curso_obj: {
      curso: '',
      nivel: 'IIº Ciclo do Ensino Segundário - Médio',
    },
    curso_objDefault: {
      curso: '',
      nivel: 'IIº Ciclo do Ensino Segundário - Médio',
    },
    ruleRequired: [value => !!value || 'campo obrigatorio'],
    config: null
  }),

  created() {
    this.initializeCursos()
  },

  methods: {
    

    closeDialog() {
      this.dialog = false
      this.curso_obj = this.curso_objDefault
      this.$refs.form.resetValidation()
    },

    openDialog() {
      this.dialog = true
    },
    loadclasse() {
      this.classesFiltered = this.classes.filter(c => c.nivel === this.turma_obj.curso.nivel_ensino)
    },
    async initializeCursos() {
      try {
        this.isLoading = true
        this.cursos = await axios
          .get('/cursoFindAll')
          .then(res => res.data)
        this.isLoading = false
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },


    async Guardar() {

      //==== FAZ A verificação se o curso já foi registrado
      let existe = this.cursos.filter(c => c.descricao.toLowerCase() === this.curso_obj.curso.toLowerCase())
      if (existe.length) {
        utilitarios.showAlertMessage('warning', 'Este curso já foi registrado.')
      } else {

        try {
          this.overlay = true
          let params = {
            curso: utilitarios.capitalize(this.curso_obj.curso),
            nivel: 'M',
            autor: ls.get('nomeUsuario')
          }
          let result = await axios.post('cursoInsertOrpdate', params)
          if (result.data.affectedRows >= 1) {
            utilitarios.showAlertMessage('success', 'Curso registrado com sucesso.')
            this.dialog = false
            this.curso_obj = this.curso_obj
            this.initializeCursos()
          } else {
            utilitarios.showAlertMessage('error', 'Ocorreu um erro ao tentar efectuar a operação.')
          }
        } catch (error) {
          this.overlay = false
          utilitarios.showAlertMessage('error', 'Ocorreu um erro ao tentar efectuar a operação.')
        } finally { this.overlay = false }


      }
    }
  }

}
</script>
 
<style scoped>
.bg {
  color: green;
  background: red
}
</style>
